import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRestockStore = defineStore('restock', () => {
  const items = ref([]);

  // 更新补货商品列表
  const updateItems = (newItems) => {
    items.value = newItems;
  };

  return { items, updateItems };
});
